import {
  B1RegularStyle,
  GhostButton,
  H8BoldStyle,
  noScrollBarStyle,
  px2rem,
} from "@moim/common";
import styled from "styled-components";

export const Dim = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

export const Container = styled.div`
  position: relative;
  width: fit-content;
  height: fit-content;
  z-index: 1;
`;

export const Root = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
`;

export const ContentContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: ${px2rem(24)} ${px2rem(24)} ${px2rem(15)};
  ${noScrollBarStyle}
`;

export const Title = styled.h3`
  ${H8BoldStyle};
  color: ${props => props.theme.colorV2.colorSet.grey800};
  font-weight: ${props => props.theme.font.bold};
  word-break: break-all;
`;

export const Content = styled.div`
  ${B1RegularStyle};
  color: ${props => props.theme.colorV2.colorSet.grey1000};
  white-space: pre-line;
  word-break: break-all;

  ${Title} + & {
    margin-top: ${px2rem(12)};
  }
`;

export const LeftButtons = styled.div``;

export const RightButtons = styled.div`
  margin-left: auto;
`;

export const Button = styled(GhostButton).attrs({
  size: "m",
})<{ textColor?: string }>`
  border: 0;
  font-weight: ${props => props.theme.font.bold};
  ${props =>
    props.textColor &&
    `color: ${props.theme.getColorByAlias(props.textColor, "#000000")}`};
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin: 0 ${px2rem(8)} ${px2rem(11)};
`;
